import client from "clients/configs";
import { Keys } from "clients/apis/_keys";
import { _goToBack } from "routers/helper";

export const onSuccessCreateRole = (res: any) => {
  const newRole = res?.data?.data;

  if (!newRole || !client.getQueryData([Keys.GET_ROLES_QRY])) return;

  client.setQueryData([Keys.GET_ROLES_QRY], (prev: any) => {
    const prevItems = prev?.data?.data?.items;

    const newItems = [...prevItems, newRole];

    return { data: { data: { items: newItems } } };
  });
};

export const onSuccessUpdateRole = (res: any) => {
  const updatedRole = res?.data?.data;

  if (!updatedRole || !client.getQueryData([Keys.GET_ROLES_QRY])) return;

  client.setQueryData([Keys.GET_ROLES_QRY], (prev: any) => {
    const prevItems = prev?.data?.data?.items;
    const newItems = prevItems.map((e: any) => {
      if (e.id === updatedRole.id) {
        return updatedRole;
      }
      return e;
    });

    return { data: { data: { items: newItems } } };
  });
};

export const onSuccessDeleteRole = (data: any, error: any, variables: any) => {
  if (!error) {
    const deletedRoleId = variables?.id;

    client.setQueryData([Keys.GET_ROLES_QRY], (prev: any) => {
      const prevItems = prev?.data?.data?.items;
      const newItems = prevItems?.filter((e: any) => e.id !== deletedRoleId);

      return { data: { data: { items: newItems } } };
    });
  }
};

export const onResponseCreateEmployee = (
  data: any,
  error: any,
  variables: any
) => {
  if (!error) {
    const user_id = data?.data?.data?.id;
    const employee_id = data?.data?.data?.staff_id;

    const newEmployee = {
      user_id,
      id: employee_id,
      role: variables?.role,
      role_id: variables?.role?.id,
      user: { id: user_id, name: variables?.name, mobile: variables?.mobile },
    };

    client.setQueryData([Keys.EMPLOYEES], (prev: any) => {
      const prevEmployees = prev?.data?.data;

      const newItems = [...prevEmployees, newEmployee];

      return { data: { data: newItems } };
    });
  }
};

export const onResponseUpdateEmployee = (
  data: any,
  error: any,
  variables: any
) => {
  if (!error) {
    const user_id = data?.data?.data?.user_id;

    const updatedEmployee = {
      user_id,
      id: variables?.id,
      role: variables?.role,
      role_id: variables?.role?.id,
      user: { id: user_id, name: variables?.name, mobile: variables?.mobile },
    };

    client.setQueryData([Keys.EMPLOYEES], (prev: any) => {
      const prevEmployees = prev?.data?.data;

      const newEmployees = prevEmployees.map((e: any) => {
        if (e.id === updatedEmployee.id) {
          return updatedEmployee;
        }
        return e;
      });

      return { data: { data: newEmployees } };
    });
  }
};

export const onResponseDeleteEmployee = (
  data: any,
  error: any,
  variables: any
) => {
  const deletedEmployeeId = variables?.id;
  client.setQueryData([Keys.EMPLOYEES], (prev: any) => {
    const prevItems = prev?.data?.data;
    const newItems = prevItems?.filter((e: any) => e.id !== deletedEmployeeId);

    return { data: { data: newItems } };
  });
};

export const onResponseUpdateEmployeePermissions = () => _goToBack();
